import { CASBIN_PAGES } from "Permission/Pages";
import { BILL_PAYMENTS_PAGE, INTEGRATION_PAGE } from "Permission/Actions";

export const BILL_PAGE_PERMISSION_PARAMS = [
  { object: CASBIN_PAGES.BILL_PAYMENTS_PAGE, action: BILL_PAYMENTS_PAGE.SUBMIT_BILL_PAYMENT },
  { object: CASBIN_PAGES.BILL_PAYMENTS_PAGE, action: BILL_PAYMENTS_PAGE.FX_RATE_CALCULATOR },
  { object: CASBIN_PAGES.BILL_PAYMENTS_PAGE, action: BILL_PAYMENTS_PAGE.BILL_TRANSACTION_PAGE_SHORTCUT },
  { object: CASBIN_PAGES.INTEGRATION_PAGE, action: INTEGRATION_PAGE.XERO_INTEGRATION },
];
